import React from 'react';

import './Footer.css';

const Footer = () => {
  return (
    <footer className="Footer">© 2018</footer>
  );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js